<!-- 地点选择 -->
<template>
  <div class="tips-block">
    <div class="loc-tool" @click="updateValue(1)">
      <div class="custom-checkbox">
        <input type="checkbox" :checked="modelValue === 1" readonly />
      </div>
      <div class="flex-1 flex-fd">
        <div class="loc-title">仅允许在当前位置定位</div>
        <div class="loc-info">只能定位参与人当前定位，不允许自定义选择位置</div>
      </div>
    </div>

    <el-divider></el-divider>

    <div class="loc-tool" @click="updateValue(2)">
      <div class="custom-checkbox">
        <input type="checkbox" :checked="modelValue === 2" readonly />
      </div>
      <div class="flex-1 flex-fd">
        <div class="loc-title">允许用户任意选择定位</div>
        <div class="loc-info">参与人可以搜索地图任意位置</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PosPermissionSelector',
    props: {
      value: {
        type: Number,
        default: null,
      },
    },
    computed: {
      modelValue: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        },
      },
    },
    methods: {
      updateValue(val) {
        this.modelValue = val
      },
    },
  }
</script>

<style scoped lang="scss">
  .tips-block {
    margin-top: 10px;
    background-color: white;
    padding: 10px 0;
  }
  .flex-1 {
    flex: 1;
  }
  .flex-fd {
    display: flex;
    flex-direction: column;
  }
  .loc-tool {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 55px;
    padding: 10px 14px;
  }
  .loc-title,
  .loc-info {
    margin-left: 10px;
  }
  .loc-title {
    font-weight: 700;
    color: #333;
  }
  .custom-checkbox {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
  }

  /* 去除 input 默认样式 */
  .custom-checkbox input[type='checkbox'] {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 20px;
    height: 20px;
    border: 2px solid #333;
    border-radius: 50%;
    background-color: transparent;
    outline: none;
    cursor: pointer;
    position: relative;
    transition: all 0.2s ease;
  }

  /* 勾选状态：蓝底 + 白勾 */
  .custom-checkbox input[type='checkbox']:checked {
    // background-color: #409eff;
    // border-color: #409eff;

    background-color: #1877fe;
    border-color: #1877fe;
  }

  /* 对勾图标 */
  .custom-checkbox input[type='checkbox']:checked::after {
    content: '';
    position: absolute;
    left: 5px;
    top: 2px;
    width: 6px;
    height: 10px;
    border: solid #fff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  /* 可选：文本样式 */
  .custom-checkbox span {
    margin-left: 8px;
    font-size: 14px;
    color: #333;
  }
  .el-divider--horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 5px 0;
  }
</style>
